/// Calculates the edit state for goal plan items
/// Permission is:
/// 0: none
/// 1: clinician
/// 2: patient (and clinician)
function canEdit(editState, permission) {
    if ((editState === 0) || (permission === 0)) {
        return false;
    } else {
        return (editState <= permission);
    }
}

export {
    canEdit
}

